<button class="downloadButton"  (click)="generatePDF()">{{ 'generatePdf' | translate }}</button>